import { useMemo } from 'react';
import { PaymentsView1 } from '@frontend/api-payments-view';
import { isSyncCompleted } from '../../../hooks/settings/use-data-sources';

export type UseCollectionsLastSyncedAtProps = {
  selectedLocationIds: string[];
  enabled?: boolean;
};
export const useCollectionsLastSyncedAt = ({
  selectedLocationIds,
  enabled = true,
}: UseCollectionsLastSyncedAtProps) => {
  const { data: sourceInfo } = PaymentsView1.Queries.useGetLocationsSourceInfoQuery({
    request: { locationIds: selectedLocationIds },
    options: { enabled: enabled && selectedLocationIds.length > 0 },
  });

  const lastSyncCompletedAt = useMemo(() => {
    if (!sourceInfo?.locationsSourceInfo) return undefined;

    for (const { sources: locationSources } of sourceInfo.locationsSourceInfo) {
      if (!locationSources) continue;
      for (const source of locationSources) {
        if (source?.capability?.bulkCollectionEnabled && isSyncCompleted(source)) {
          return source.lastSyncCompletedAt;
        }
      }
    }
    return undefined;
  }, [sourceInfo]);

  return lastSyncCompletedAt;
};
